import { render } from "./ContractCreateComponent.vue?vue&type=template&id=5f30a569"
import script from "./ContractCreateComponent.vue?vue&type=script&lang=js"
export * from "./ContractCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__